import i18n from '@/i18n';

export default [
  {
    path: '/business-users',
    name: 'business-users',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'user',
          actions: ['view-nav-link-business'],
        },
      ],
      title: i18n.global.t('business_users')
    },
    // route level code-splitting
    component: () =>
      import('../../views/businessUsers/Index'),
    children: [
      {
        path: 'invite',
        name: 'business-users-invite',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'user',
              actions: ['invite'],
            },
          ],
          title: i18n.global.t('business_users'),
        },
        component: () => import('../../views/businessUsers/InviteMember.vue'),
      },
    ],
  },
  {
    path: '/invitation/join/:token',
    name: 'invite-business-user',
    meta: {
      loadState: true,
      auth: false,
      isAuthPage: true,
      title: i18n.global.t('join_business')
    },
    // route level code-splitting
    component: () =>
      import('../../views/businessUsers/Invite'),
  },
];
